import { FormattedMessage, useIntl } from 'react-intl';

import confetti1 from '@/assets/icons/freemium/confetti-1.png';
import confetti2 from '@/assets/icons/freemium/confetti-2.png';
import partyPopper from '@/assets/icons/freemium/party-popper.png';
import { CloseIcon } from '@/components/icons/close';
import { Button } from '@/components/ui/button';
import { Typography } from '@/components/ui/typography';
import { useFreemiumMigrationBanner } from '@/hooks/use-freemium-migration-banner';

export function FreemiumMigrationBanner() {
  const intl = useIntl();
  const { show, dismiss } = useFreemiumMigrationBanner();

  if (!show) return null;

  return (
    <section
      className="bg-fx-brand-600 relative overflow-hidden rounded-lg p-4"
      data-testid="freemium-migration-banner"
      aria-labelledby="freemium-migration-banner-title"
    >
      <img
        src={confetti1}
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 h-full w-full object-cover"
      />
      <img
        src={confetti2}
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute top-0 right-0 h-full object-contain"
      />
      <div className="relative z-10 flex items-start gap-4">
        <img
          src={partyPopper}
          alt=""
          aria-hidden="true"
          width={35}
          height={35}
          className="mt-0.5 size-[35px] shrink-0"
        />
        <div className="min-w-0 flex-1">
          <Typography
            id="freemium-migration-banner-title"
            variant="large2"
            className="text-white"
          >
            <FormattedMessage
              defaultMessage="Everything from Sponsored Postings is now in Source"
              description="Headline telling recruiters that Sponsored Postings campaigns now live in Source"
            />
          </Typography>
          <Typography variant="body1" className="text-white">
            <FormattedMessage
              defaultMessage="Every campaign, channel, and cost metric from Sponsored Postings now lives here. Launch campaigns, manage channels, and track spend across all your channels"
              description="Explanation that every campaign, channel, and cost metric from Sponsored Postings is now managed in Source"
            />
          </Typography>
        </div>
        <Button
          type="button"
          variant="icon"
          size="icon"
          className="size-6 shrink-0 text-white hover:bg-white/20"
          onClick={dismiss}
          data-testid="freemium-migration-banner-dismiss"
          aria-label={intl.formatMessage({
            defaultMessage: 'Dismiss',
            description:
              'Accessible name for the control that hides the Sponsored Postings migration notice',
          })}
        >
          <CloseIcon className="text-white" />
        </Button>
      </div>
    </section>
  );
}
